import { Box } from '@chakra-ui/react';
import { Pressable, VStack, Text } from 'components/ui';
import { FORM_ACTIONS } from '../../../utils/formActions.js';
import { cacheFormDataInLocalStorage } from '../../../utils/formReducer.js';
import { Pill } from '../Pill';

export const GENDER_OPTIONS = ['Male', 'Female', 'Other', 'Prefer not to say'];

export const Gender = ({ dispatch, formData }) => {
  const updateGender = (data) => {
    const cacheData = JSON.stringify({ ...formData, gender: data });
    cacheFormDataInLocalStorage(cacheData);
    dispatch({
      type: FORM_ACTIONS.UPDATE_FORM_FIELD,
      fieldName: `gender`,
      payload: data,
    });
  };

  return (
    <VStack data-testid="onboarding-gender" gap="10px" alignItems={'flex-start'}>
      <Text textStyle="label.section" textAlign="left">
        Gender identity
      </Text>

      <Box display="flex" flexDirection="row" flexWrap="wrap" gap="9px">
        {GENDER_OPTIONS.map((option) => (
          <Pressable
            key={option}
            onClick={() => updateGender(option)}
            data-testid={'onboarding-gender-item'}
          >
            <Pill isSelected={formData.gender === option} text={option} />
          </Pressable>
        ))}
      </Box>
    </VStack>
  );
};

export default Gender;
